import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, StackLayout, Text } from '@salt-ds/core';
import { ErrorSolidIcon } from '@salt-ds/icons';

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Application error:', error, errorInfo);
    if (error.name === 'ChunkLoadError') {
      const reloadKey = 'chunk-error-reload';
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1');
        window.location.reload();
      }
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    if (this.state.error?.name === 'ChunkLoadError') {
      return null;
    }

    const { t } = this.props;

    return (
      <StackLayout
        gap={3}
        align="center"
        style={{
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center',
          padding: '0 24px'
        }}
      >
        <ErrorSolidIcon size={2} style={{ color: 'var(--salt-status-error-foreground)' }} />
        <StackLayout gap={1} align="center">
          <Text styleAs="h4">
            <strong>{t('errorBoundary.title')}</strong>
          </Text>
          <Text>{t('errorBoundary.message')}</Text>
        </StackLayout>
        <Button onClick={() => window.location.reload()}>{t('errorBoundary.reloadButton')}</Button>
        <Button
          variant="secondary"
          onClick={() => {
            window.location.hash = '#/';
            window.location.reload();
          }}
        >
          {t('errorBoundary.homeButton')}
        </Button>
      </StackLayout>
    );
  }
}

export { ErrorBoundary };
export default withTranslation()(ErrorBoundary);
